import { Component } from '@angular/core';

@Component({
  selector: 'fnsr-home',
  templateUrl: './home.component.html'
})
export class HomeComponent {

}
